import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import ContentLoader from "react-content-loader";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import Helper from "../../../Helper";

import { getTrans as t } from "../../../Localization/translations";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import RatecardService from "../../../services/inventory/viewRatecardServices";

function ViewRateCard() {
  const [cardname, setCardName] = useState("");
  const [effectiveform, setEffectiveFormdate] = useState("");
  const [effectivetodate, setEffectiveTodate] = useState("");

  //  InvoiceLInes //
  const [line_items, SetLine_Items] = useState([]);
  const [extrafiledinvoice, setExtraFiled] = useState([]);

  const [loading, setLoading] = useState(true);

  const { state } = useLocation();
  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existinvoice);
    })
  };

  useEffect(() => {
    getExtrafiled();
    RatecardService.getRatecardDetails(state).then((response) => {
      setCardName(response.data.cardname);
      setEffectiveTodate(response.data.effectiveto);
      setEffectiveFormdate(response.data.effectiveform);
      SetLine_Items(response.data.ratecardline);
      setLoading(false);
    })
  }, []);

  return (
    <>
      <div className="container-fluid">
        {loading === false ? (
          <>
            <div className="row">
              <div className="header pt-3">
                <h5 className="title mb-0 ">{t("Rate Card")}</h5>
                <h6>
                  <Link to="/ratecard" className="tc">
                    {t("Rate Card")}
                  </Link>{" "}
                  / <span>{t("View Ratecard")}</span>
                </h6>
              </div>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="success"></div>
                    <div className="row">
                      <div className="row">
                        <div className="form-group row">
                          <div className="col-xl-3">
                            <label className="col-lg-8 col-form-label">
                              {t("Card Name")}{" "}
                              <Tooltip content={t("CardName_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                          </div>
                          <div className="col-xl-4">
                            <span className="col-lg-8 view-label p">
                              {cardname ? cardname : "None"}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-xl-3">
                          <label className="col-lg-6 col-form-label">
                            {t("Effective Form")}{" "}
                            <Tooltip content={t("EffectiveFrom_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                        </div>
                        <div className="col-xl-4">
                          <span className="col-lg-8 view-label p">
                            {effectiveform
                              ? Helper.DateNormal(effectiveform)
                              : "None"}
                          </span>
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-xl-3">
                          <label className="col-lg-6 col-form-label">
                            {t("Effective To")}{" "}
                            <Tooltip content={t("EffectiveTo_Tooltip")}>
                              <i className="fa fa-light fa-circle-info"></i>
                            </Tooltip>
                          </label>
                        </div>
                        <div className="col-xl-4">
                          <span className="col-lg-8 view-label p">
                            {effectivetodate
                              ? Helper.DateNormal(effectivetodate)
                              : "None"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row" id="payschedule" style={{ marginTop: "5px" }}>
              <div className="col-md-12">
                <div className="">
                  <div className="body">
                    <div className="table-responsive">
                      <MaterialTable
                        style={{
                          padding: "0.5rem 0.5rem",
                          backgroundColor: "var(--bs-table-bg)",
                          borderBottomWidth: "1px",
                          boxShadow:
                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                        }}
                        columns={[
                          {
                            title: `${t("Category")}`,
                            field: "category_name",
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                            render:  rowData  =>   <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Category")}{" "}
                            </div>
                           <div className="">{(rowData.category_name)}</div></>
                          },
                          {
                            title: `${t("Sub Category")}`,
                            field: "subcategory_name",
                            render:  rowData  =>   <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Sub Category")}{" "}
                            </div>
                           <div className="">{(rowData.subcategory_name)}</div></>,                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Frequency")}`,
                            field: "frequency",
                            render:  rowData  =>   <>
                            <div className="d-xl-none tc d-md-none d-lg-none">
                              {t("Frequency")}{" "}
                            </div>
                           <div className="">{(rowData.frequency)}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Term Form")}`,
                            field: "term",
                            render: (rowData) =><><div className="d-xl-none tc d-md-none d-lg-none">{t("Term Form")}</div><div>{rowData.term}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Term To")}`,
                            field: "termto",
                            render: (rowData) => <><div className="d-xl-none tc d-md-none d-lg-none">{t("Term To")}</div><div>{rowData.termto}</div></>,

                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Rate Basis")}`,
                            field: "ratebasis",
                            render: (rowData) =><><div className="d-xl-none tc d-md-none d-lg-none">{t("Rate Basis")}</div><div>{rowData.ratebasis}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                          {
                            title: `${t("Amount")}`,
                            field: "amount",
                            render: (rowData) =><><div  className={`d-xl-none tc d-md-none d-lg-none`} style={{ textAlign: rowData.isSmallScreen ? 'left' : 'right', fontSize: '12px', fontWeight: rowData.isSmallScreen ? 'bold' : '' }}
                            >{t("Amount")}</div>
                            <div className={`d-none d-xl-block d-lg-block text-right`} style={{ textAlign: 'right', fontSize: '12px' }}>{Helper.Amount(rowData.amount)}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "right",
                            },
                            // cellStyle: {
                            //   textAlign: "right",
                            //   fontSize: 12,
                            // },
                          },
                          {
                            title: `${t("Product")}`,
                            field: "product",
                            render: (rowData) =><><div className="d-xl-none tc d-md-none d-lg-none">{t("Product")}</div><div>{rowData.product}</div></>,
                            headerStyle: {
                              verticalAlign: "inherit",
                              fontWeight: "bold",
                              textAlign: "left",
                            },
                            cellStyle: {
                              textAlign: "left",
                              fontSize: 12,
                            },
                          },
                        ]}
                        data={line_items}
                        options={{
                          headerStyle: {
                            backgroundColor: "white",
									color: "#245C7F",
                            fontSize: 12,
                          },
                          rowStyle: (rowData, index) => {
                            if (index % 2) {
                              return { backgroundColor: "#fff" };
                            }
                          },
                          sorting: true,
                          search: false,
                          toolbar: false,
                          paging: true,
                          pageSize: 15, // make initial page size
                          emptyRowsWhenPaging: false, // To avoid of having empty rows
                          pageSizeOptions: [15, 20, 25, 50],
                          paginationType: "stepped",
                          showFirstLastPageButtons: false,
                          actionsColumnIndex: -1,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <ContentLoader
            viewBox="0 0 400 160"
            backgroundColor="rgba(0,0,0,0.06)"
            foregroundColor="rgba(0,0,0,0.12)"
          >
            <rect x="0" y="13" rx="4" ry="4" width="400" height="9" />
            <rect x="0" y="29" rx="4" ry="4" width="100" height="8" />
            <rect x="0" y="50" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="65" rx="4" ry="4" width="400" height="10" />
            <rect x="0" y="79" rx="4" ry="4" width="100" height="10" />
            <rect x="0" y="99" rx="5" ry="5" width="400" height="200" />
          </ContentLoader>
        )}
      </div>
    </>
  );
}

export default ViewRateCard;
